module.exports = __webpack_public_path__ + "img/mind_template_item_5_3.6a1aec1d.png";